import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import classNames from 'classnames'
import { IconPlus } from '@tabler/icons-react'
import { Button } from '@/components/buttons/Button'

import { playbookTitlesSectionMap, accessors, accessorSectionMap } from '../playbook.helpers'

export const PlaybookSectionHeader = ({ buttonText, buttonDisabled }) => {
  const history = useHistory()
  const { id, section } = useParams()
  const accessor = accessorSectionMap[section]

  const handleCreate = (event) => {
    if (buttonDisabled) {
      event.preventDefault()
    } else {
      history.push(`/playbooks/${id}/${section}/create`)
    }
  }

  return (
    <header
      className={classNames('playbook-section-header', { checklist: accessor === 'checklist' })}
      data-testid="playbook-section-header"
    >
      <h2>{playbookTitlesSectionMap[section]}</h2>
      <Button
        small
        data-testid={`${section}-create-button`}
        onClick={handleCreate}
        disabled={buttonDisabled && accessor === accessors.STICKY_NOTE}
        disabledTooltip="You can only add one sticky note"
        style={{ marginRight: '40px' }}
      >
        <IconPlus />
        {buttonText}
      </Button>
    </header>
  )
}
